import {Pipe, PipeTransform} from '@angular/core';
import {layoutPaths} from '../..';

@Pipe({name: 'baKameleonPicture'})
export class BaKameleonPicturePipe implements PipeTransform {

  transform(input:string):string {
    return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/theme/pipes/baKameleonPicture/baKameleonPicture.pipe.ts